import * as React from "react";

export function Instagram(props) {
  return (
    <svg
      width={58}
      height={53}
      viewBox="0 0 58 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.229.322C12.588.514 8.568 1.558 5.32 4.533 2.062 7.523.942 11.238.732 15.463.602 18.1-.16 38.019 2.051 43.243c1.492 3.525 4.43 6.234 8.295 7.611 1.803.646 3.862 1.083 6.883 1.21 25.253 1.052 34.614.48 38.561-8.82.7-1.656 1.183-3.549 1.316-6.32 1.154-23.297-.187-28.346-4.588-32.39C49.027 1.328 44.92-.853 17.228.321zm.232 47.057c-2.765-.114-4.265-.538-5.266-.895-2.518-.9-4.41-2.634-5.383-4.937-1.684-3.97-1.125-22.822-.975-25.873.147-2.988.805-5.719 3.097-7.827 2.835-2.603 6.5-3.879 31.446-2.843 3.256.136 6.23.74 8.528 2.843 2.836 2.603 4.242 6 3.096 28.866-.124 2.538-.587 3.915-.975 4.834-2.567 6.051-8.47 6.892-33.568 5.832zm23.194-35.081c0 1.723 1.523 3.124 3.403 3.124 1.88 0 3.406-1.401 3.406-3.124s-1.525-3.123-3.406-3.123c-1.88 0-3.403 1.4-3.403 3.123zM14.36 26.192c0 7.382 6.52 13.366 14.562 13.366s14.562-5.984 14.562-13.366-6.52-13.363-14.562-13.363c-8.043 0-14.562 5.981-14.562 13.363zm5.11 0c0-4.79 4.23-8.675 9.452-8.675 5.22 0 9.452 3.886 9.452 8.675 0 4.792-4.231 8.679-9.452 8.679s-9.452-3.887-9.452-8.68z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
